import { MACKENZIE_HYBRIDA_APPLICATION_ID, MACKENZIE_PROPRIA_APPLICATION_ID } from './constants'

const isDisableChangePersonalData = ({ byIntegration, externalReferences, canChangePassword }) => {
  let isMackenzie = false

  if (externalReferences) {
    isMackenzie = externalReferences.some(
      ({ applicationId }) =>
        applicationId === MACKENZIE_HYBRIDA_APPLICATION_ID ||
        applicationId === MACKENZIE_PROPRIA_APPLICATION_ID,
    )
  }

  if (isMackenzie) {
    return true
  }

  if (canChangePassword) {
    return byIntegration && !canChangePassword
  }

  return byIntegration
}

export default isDisableChangePersonalData
